// GZ#2998: error #163 (RangeError: Maximum call stack size exceeded) fires on
// /calendars in Safari with no usable stack, and no test browser reproduces
// it. Name the popups that are open when any error is reported, so the next
// real hit tells us which screen was on top.
const MUI_KINDS = ["Dialog", "Drawer", "Popover", "Menu", "Popper"];
const MAX_LABEL = 48;
const MAX_DIALOGS = 5;

const shorten = (text: string): string => {
  const clean = text.replace(/\s+/g, " ").trim();
  return clean.length > MAX_LABEL ? `${clean.slice(0, MAX_LABEL - 1)}…` : clean;
};

const titleOf = (el: Element, doc: Document): string => {
  const aria = el.getAttribute("aria-label") || el.querySelector("[aria-label][role='dialog']")?.getAttribute("aria-label");
  if (aria) return aria;
  const labelledBy = el.getAttribute("aria-labelledby");
  const labelled = labelledBy ? doc.getElementById(labelledBy)?.textContent : "";
  if (labelled) return labelled;
  const heading = el.querySelector(".MuiDialogTitle-root, h1, h2, h3, h4, h5, h6");
  return heading?.textContent || "";
};

export function describeOpenDialogs(doc: Document = document): string[] {
  const found: string[] = [];
  doc.querySelectorAll(".MuiModal-root, [role='dialog']").forEach((el) => {
    // A role=dialog inside a MUI modal is the same popup.
    if (!el.classList.contains("MuiModal-root") && el.closest(".MuiModal-root")) return;
    const kind =
      MUI_KINDS.find((k) => el.classList.contains(`Mui${k}-root`)) ||
      (el.classList.contains("MuiModal-root") ? "Modal" : "dialog");
    const title = titleOf(el, doc);
    found.push(shorten(title ? `${kind}: ${title}` : kind));
  });
  return found.slice(0, MAX_DIALOGS);
}

export function withOpenDialogs<T extends { extra?: Record<string, unknown> }>(
  event: T,
  doc: Document | undefined = typeof document === "undefined" ? undefined : document,
): T {
  if (!doc) return event;
  try {
    const open = describeOpenDialogs(doc);
    if (open.length) event.extra = { ...(event.extra || {}), open_dialogs: open };
  } catch {
    /* never let the marker break error reporting */
  }
  return event;
}
